import { ElBacktop as r } from "element-plus";
import { resolveComponent as t, openBlock as s, createElementBlock as p, createVNode as c, normalizeProps as m, guardReactiveProps as l, withCtx as i, createElementVNode as _, renderSlot as d } from "vue";
import { _ as k } from "../_plugin-vue_export-helper-dad06003.js";
const f = {
  name: "rBackTop",
  components: {
    Backtop: r
  }
}, u = { class: "r-back-top" };
function B(o, b, v, $, h, E) {
  const a = t("r-icon"), n = t("Backtop");
  return s(), p("div", u, [
    c(
      n,
      m(l(o.$attrs)),
      {
        default: i(() => [
          _("template", null, [
            d(o.$slots, "default", {}, () => [
              c(a, {
                name: "icon-back",
                class: "r-back-top-arrow"
              })
            ])
          ])
        ]),
        _: 3
        /* FORWARDED */
      },
      16
      /* FULL_PROPS */
    )
  ]);
}
const e = /* @__PURE__ */ k(f, [["render", B], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/back-top/back-top.vue"]]);
e.install = function(o) {
  o.component(e.name, e);
};
export {
  e as default
};
